import { BonusCustomerCondition } from '@synergy/models';

import { PoolMath } from './pool-math';
import { getConditionValue } from './get-condition-value';

interface SettlementWithConditionValues {
    bonusConditionValues: { bonusConditionId: number; value?: number | null }[];
}

/**
 * What one bonus condition comes to over all members: the summed revenue or
 * quantity, and the bonus as the sum of the members' bonuses, each rounded to
 * the cent. The settlement and its invoice count it that way; the revenue
 * times the rate, rounded once, came out a few cents off (#2268).
 */
export const getConditionTotals = (
    condition: BonusCustomerCondition,
    settlements: SettlementWithConditionValues[]
): { value: number; bonus: number } => {
    const rate = getConditionValue(condition);
    const values = settlements.map(
        settlement =>
            settlement.bonusConditionValues.find(bcv => bcv.bonusConditionId === condition.bonusCondition.id)?.value ||
            0
    );

    return {
        value: values.reduce((sum, value) => sum + value, 0),
        bonus: PoolMath.round(values.reduce((sum, value) => sum + PoolMath.round(value * rate), 0)),
    };
};
